export default Object.freeze({
    en: {
        MONDAY: { name: 'Monday', value: 'mon' },
        TUESDAY: { name: 'Tuesday', value: 'tue' },
        WEDNESDAY: { name: 'Wednesday', value: 'wed' },
        THURSDAY: { name: 'Thursday', value: 'thu' },
        FRIDAY: { name: 'Friday', value: 'fri' },
        SATURDAY: { name: 'Saturday', value: 'sat' },
        SUNDAY: { name: 'Sunday', value: 'sun' },
    },
    sr: {
        MONDAY: { name: 'Ponedeljak', value: 'mon' },
        TUESDAY: { name: 'Utorak', value: 'tue' },
        WEDNESDAY: { name: 'Sreda', value: 'wed' },
        THURSDAY: { name: 'Četvrtak', value: 'thu' },
        FRIDAY: { name: 'Petak', value: 'fri' },
        SATURDAY: { name: 'Subota', value: 'sat' },
        SUNDAY: { name: 'Nedelja', value: 'sun' },
    },
    ru: {
        MONDAY: { name: 'Понедельник', value: 'mon' },
        TUESDAY: { name: 'Вторник', value: 'tue' },
        WEDNESDAY: { name: 'Среда', value: 'wed' },
        THURSDAY: { name: 'Четверг', value: 'thu' },
        FRIDAY: { name: 'Пятница', value: 'fri' },
        SATURDAY: { name: 'Суббота', value: 'sat' },
        SUNDAY: { name: 'Воскресенье', value: 'sun' },
    },
    bih: {
        MONDAY: { name: 'Ponedeljak', value: 'mon' },
        TUESDAY: { name: 'Utorak', value: 'tue' },
        WEDNESDAY: { name: 'Srijeda', value: 'wed' },
        THURSDAY: { name: 'Četvrtak', value: 'thu' },
        FRIDAY: { name: 'Petak', value: 'fri' },
        SATURDAY: { name: 'Subota', value: 'sat' },
        SUNDAY: { name: 'Nedelja', value: 'sun' },
    },
})
